import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';

import Utils from 'src/app/utils';

import moment from 'moment';
declare var require: any
declare var $: any;


@Component({
  selector: 'app-worker-mandown',
  templateUrl: './worker-mandown.component.html',
  styleUrls: ['./worker-mandown.component.scss']
})
export class WorkerMandownComponent implements OnInit {

  workers: any;

  monitor = '';
  group = '';

  monitors:any = [];
  groups:any = [];
  date:any = moment().format("ddd D MMM YYYY");

  u = Utils;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.getWorkers();

    //console.log(this.date);

    setTimeout( () => {
      $('.datepicker').datepicker({format: 'D d M yyyy'});
    }, 1000 );

  }

  getWorkers(){

    if(this.monitor == null){
      this.monitor = '';
    }

    if(this.group == null){
      this.group = '';
    }
    
    this.date = $('.datepicker').val() ? $('.datepicker').val() : this.date;

    //console.log({monitor:this.monitor,group:this.group});

    this.okService.get('reports/workermandown',{monitor:this.monitor,group:this.group,date:this.date})
    .subscribe((data) => {

      this.workers = data.body;
      this.groups = this.okService.groups;
      this.monitors = this.okService.monitors;

    });
  }

  updateFilter(){
    this.getWorkers();
  }

  clearFilter(){
    this.monitor = '';
    this.group = '';
    this.updateFilter();
  }

  export(){

    if(this.monitor == null){
      this.monitor = '';
    }

    if(this.group == null){
      this.group = '';
    }

    let fields:any = {'export':true};
    fields['monitor'] = this.monitor;
    fields['group'] = this.group;
    fields['date'] = this.date;



    this.okService.download("reports/workermandown",fields);

  }

}
